import {get, postQ} from "../apiconfig";
import {localGet} from "../utils/tools";
import global from "../config/global";

export default {

  /**
   * 获得关注的朋友圈动态列表
   * @param currentCount
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  loadFollowingMomentList(currentCount = 0, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return get('api/Moment/GetMomentListFollowing', ['session=' + localGet(global.key.session), 'currentCount=' + currentCount], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },

  /**
   * 获得热门的朋友圈动态列表
   * @param currentCount
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  loadHoTMomentList(currentCount = 0, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return get('api/Moment/GetMomentListHot', ['session=' + localGet(global.key.session), 'currentCount=' + currentCount], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },

  /**
   * 获得新的朋友圈动态列表
   * @param currentCount
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  loadNewMomentList(currentCount = 0, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return get('api/Moment/GetMomentListNew', ['session=' + localGet(global.key.session), 'currentCount=' + currentCount], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },
  /**
   * 获得指定账号
   * @param currentCount
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  loadAnchorMomentList(accountId,currentCount = 0, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return get('api/Moment/GetMomentListByAccount', ['session=' + localGet(global.key.session), 'currentCount=' + currentCount,'accountId='+accountId], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },

  /**
   * 获取朋友圈动态关于我的未读评论数量
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   */
  loadMineCommentUnread(successCallback = null, failCallBack = null, vueObj) {
    return get('api/Moment/GetMomentCommentUnreadCountAboutMe', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, false, false);
  },
  /**
   * 获取朋友圈关于我的评论
   * @param currentCount
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  loadMineCommentList(currentCount = 0, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return get('api/Moment/GetMomentCommentListAboutMe', ['session=' + localGet(global.key.session), 'currentCount=' + currentCount], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },

  /**
   * 获取朋友圈指定动态的评论
   * @param momentId
   * @param currentCount
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  loadMomentCommentList(momentId, currentCount = 0, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return get('api/Moment/GetMomentCommentList', ['session=' + localGet(global.key.session), 'currentCount=' + currentCount, 'momentId=' + momentId], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },

  /**
   * 获取朋友圈动态详细评论
   * @param commentId
   * @param currentCount
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @param showLoading
   * @param hideLoading
   * @returns {undefined|Promise<unknown>}
   */
  loadCommentDetail(commentId,  successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return get('api/Moment/GetMomentCommentListDetailed', ['session=' + localGet(global.key.session),  'commentId=' + commentId], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },

  /**
   * 获取指定朋友圈动态详情
   * @param momentId
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  loadMomentDetail(momentId, successCallback = null, failCallBack = null, vueObj) {
    return get('api/Moment/GetMomentById', ['session=' + localGet(global.key.session), 'momentId=' + momentId], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj);
  },

  /**
   * 点赞朋友圈动态
   * @param momentId
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   */
  doLikeMoment(momentId, successCallback = null, failCallBack = null, vueObj,showLoading=false) {
    return postQ('api/Moment/LikeMoment', ['session=' + localGet(global.key.session), 'momentId=' + momentId], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)

    }, '/webApp', vueObj,showLoading,showLoading);
  },

  /**
   * 取消朋友圈动态点赞
   * @param momentId
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  doCancelLikeMoment(momentId, successCallback = null, failCallBack = null, vueObj,showLoading=false) {
    return postQ('api/Moment/UnlikeMoment', ['session=' + localGet(global.key.session), 'momentId=' + momentId], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj,showLoading,showLoading);
  },

  /**
   * 举报朋友圈动态
   * @param momentId
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  doReportMoment(momentId, successCallback = null, failCallBack = null, vueObj) {
    return postQ('api/Moment/ReportMoment', ['session=' + localGet(global.key.session), 'momentId=' + momentId], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj);
  },
  /**
   * 举报朋友圈动态评论
   * @param commentId
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  doReportComment(commentId, successCallback = null, failCallBack = null, vueObj) {
    return postQ('api/Moment/ReportComment', ['session=' + localGet(global.key.session), 'commentId=' + commentId], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj);
  },

  /**
   * 评论朋友圈动态
   * @param momentId
   * @param content
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  doCommentMoment(momentId, content, successCallback = null, failCallBack = null, vueObj) {
    return postQ('api/Moment/CommentMoment', ['session=' + localGet(global.key.session), 'momentId=' + momentId, 'content=' +encodeURIComponent(content)], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj);
  },
  /**
   * 回复评论
   * @param commentId
   * @param content
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  doReplyComment(commentId, content, successCallback = null, failCallBack = null, vueObj) {
    return postQ('api/Moment/ReplyComment', ['session=' + localGet(global.key.session), 'commentId=' + commentId, 'content=' + encodeURIComponent(content)], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj);
  },

  /**
   * 删除评论
   * @param commentId
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  doDeleteComment(commentId, successCallback = null, failCallBack = null, vueObj) {
    return postQ('api/Moment/DeleteComment', ['session=' + localGet(global.key.session), 'commentId=' + commentId], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj);
  },

  /**
   * 设置朋友圈动态已阅
   * @param momentId
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  viewMoment(momentId, successCallback = null, failCallBack = null, vueObj){
    return postQ('api/Moment/SetMomentRead', ['session=' + localGet(global.key.session), 'momentId=' + momentId], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj,false,false);
  },

  /**
   * 设置已关注的朋友圈动态已阅
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  viewFollowingMoment(successCallback = null, failCallBack = null, vueObj){
    return postQ('api/Moment/SetMomentListFollowingRead', ['session=' + localGet(global.key.session), 'momentId='], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj,false,false);
  }
}



// WEBPACK FOOTER //
// ./src/api/moment-api.js